import React from 'react';
import { Box, Typography, Button, Card, CardContent, Container } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckCircle } from '@mui/icons-material';
import '../../styles/mobidawg-style.scss';
import { Home } from '@mui/icons-material';

function ContactConfirmation() {
    const location = useLocation();
    const navigate = useNavigate();
    const { projectId, projectTitle } = location.state || {};

    // Redirect if no project data
    if (!projectId || !projectTitle) {
        return (
            <Container maxWidth="sm" sx={{ mt: 4 }}>
                <Typography variant="h5" color="error">
                    Error: No submission data found. Please try again.
                </Typography>
                <Button 
                    variant="contained" 
                    onClick={() => navigate('/contactform')}
                    sx={{ mt: 2 }}
                >
                    Back to Contact Form
                </Button>
            </Container>
        );
    }

    const handleConfirm = () => {
        navigate('/contactregistrylist');
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 4, mb: 4 }}>
            <Card sx={{ 
                textAlign: 'center',
                boxShadow: 3,
                borderRadius: 2
            }}>
                <CardContent sx={{ py: 4 }}>
                    {/* Success Icon */}
                    <CheckCircle 
                        sx={{ 
                            fontSize: 48, 
                            color: '#4caf50',
                            mb: 2
                        }} 
                    />

                    {/* Success Message */}
                    <Typography 
                        variant="h4" 
                        sx={{ 
                            fontWeight: 'bold',
                            mb: 2,
                            color: '#013220'
                        }}
                    >
                        Thank You!
                    </Typography>

                    <Typography 
                        variant="body1" 
                        sx={{ 
                            mb: 3,
                            color: '#555'
                        }}
                    >
                        Your project request has been successfully submitted.
                    </Typography>

                    {/* Project Details */}
                    <Box sx={{ 
                        backgroundColor: '#f5f5f5',
                        p: 2,
                        borderRadius: 1,
                        mb: 3,
                        border: '1px solid #ddd'
                    }}>
                        <Typography 
                            variant="body2" 
                            sx={{ color: '#666', mb: 1 }}
                        >
                            <b>Project Title:</b>
                        </Typography>
                        <Typography 
                            variant="body1" 
                            sx={{ 
                                mb: 2,
                                color: '#013220',
                                fontWeight: 500
                            }}
                        >
                            {projectTitle}
                        </Typography>

                        <Typography 
                            variant="body2" 
                            sx={{ color: '#666', mb: 1 }}
                        >
                            <b>Transaction ID:</b>
                        </Typography>
                        <Typography 
                            variant="h6" 
                            sx={{ 
                                color: '#c54a4a',
                                fontFamily: 'monospace',
                                fontWeight: 'bold'
                            }}
                        >
                            {projectId}
                        </Typography>
                    </Box>

                    <Typography 
                        variant="body2" 
                        sx={{ 
                            mb: 3,
                            color: '#999'
                        }}
                    >
                        Please save this ID for your records. Our team will review your request and contact you shortly.
                    </Typography>

                    {/* Confirm Button */}
                    <Button 
                        variant="contained" 
                        color="primary"
                        onClick={handleConfirm}
                        sx={{ 
                            backgroundColor: '#013220',
                            color: 'white',
                            padding: '10px 30px',
                            fontSize: '1rem',
                            '&:hover': {
                                backgroundColor: '#0a1f14'
                            }
                        }}
                    >
                        View Project Submissions
                    </Button>
                </CardContent>
            </Card>
        </Container>
    );
}

export default ContactConfirmation;
